export default {
  empty: require('../assets/lottie/empty.json'),
  vacation: require('../assets/lottie/vacation.json'),
  relaxing: require('../assets/lottie/relaxing.json'),
  getPaid: require('../assets/lottie/getPaid.json'),
  confirmCalendar: require('../assets/lottie/confirmCalendar.json'),
  maintenance: require('../assets/lottie/maintenance.json'),
};
